"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [randomIntegerInRange 生成指定范围的随机整数]
 *
 * @param   {[Number]}  min  [min 最小值]
 * @param   {[Number]}  max  [max 最大值]
 *
 * @return  {[Number]}       [return description]
 */
var randomIntegerInRange = exports.randomIntegerInRange = function randomIntegerInRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
/**
 * [randomNumberInRange 生成指定范围的随机小数]
 *
 * @param   {[Number]}  min  [min 最小值]
 * @param   {[Number]}  max  [max 最大值]
 *
 * @return  {[type]}       [return description]
 */
var randomNumberInRange = exports.randomNumberInRange = function randomNumberInRange(min, max) {
  return Math.random() * (max - min) + min;
};
/**
 * [round 四舍五入到指定位数]
 *
 * @param   {[Number]}  n         [n 数字]
 * @param   {[Number]}  decimals  [decimals 指定位数]
 *
 * @return  {[Number]}            [return description]
 */
var round = exports.round = function round(n) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return Number(Math.round(n + "e" + decimals) + "e-" + decimals);
};
exports.default = {
  randomIntegerInRange: randomIntegerInRange,
  randomNumberInRange: randomNumberInRange,
  round: round
};